import { createAsyncThunk, createDraftSafeSelector, createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import BigNumber from "bignumber.js";
import { mergeObject } from "src/utils";
import { FS } from "../other/constance";

const client = Axios.create({
  baseURL: "https://backend-nft-app.trava.finance",
});

export const fetchFarmingData = createAsyncThunk("farmingSlice/fetchFarmingData", async (_, thunkAPI) => {
  // prettier-ignore
  await Promise.all([
    thunkAPI.dispatch(fetchVaultsMeta()), 
    thunkAPI.dispatch(fetchVaultRegistryData({ page: 1, vaultType: "copper" })),
  ]);
});

export const fetchVaultsMeta = createAsyncThunk("farmingSlice/fetchVaultsMeta", async () => {
  const res = await client.get("/v1/vaults/meta").then((res) => res.data);
  return res;
});

export const fetchVaultRegistryData = createAsyncThunk("farmingSlice/fetchVaultRegistryData", async (params) => {
  const { page, limit = 5, vaultType, sort = "-rewardClaimed", owner } = params;

  const res = await client
    .get("/v1/vaults/", {
      params: {
        vaultType,
        isStake: true,
        page,
        limit,
        sort,
        owner,
      },
    })
    .then((res) => res.data);
  return res;
});

const initialState = {
  fetchFarmingDataStatus: FS.INITIAL,
  vaultStatistic: undefined,
  vaultRegistry: undefined,
  vaultRegistryConfig: {
    page: 1,
    rowsPerPage: 5,
    vaultType: "copper",
    order: "desc",
    orderBy: "rewardClaimed",
  },
  topAddressEarned: [],
};

const farmingSlice = createSlice({
  name: "farmingSlice",
  initialState: initialState,
  reducers: {
    updateVaultRegistryConfig: (state, action) => {
      state.vaultRegistryConfig = mergeObject(state.vaultRegistryConfig, action.payload);
    },
  },
  extraReducers: (builder) =>
    builder
      // fetch farming data
      .addCase(fetchFarmingData.pending, (state, _) => {
        state.fetchFarmingDataStatus = FS.FETCHING;
      })
      .addCase(fetchFarmingData.fulfilled, (state, _) => {
        if (state.fetchFarmingDataStatus !== FS.FAIL) {
          state.fetchFarmingDataStatus = FS.SUCCESS;
        }
      })

      // fetch vaults metadata
      .addCase(fetchVaultsMeta.fulfilled, (state, action) => {
        state.topAddressEarned = action.payload.topAddressEarned.map((item) => ({
          ...item,
          totalTravaEarned: BigNumber(item.totalTravaEarned).dividedBy(1e18).toNumber(),
        }));
        state.vaultStatistic = {
          totalTravaEarned: BigNumber(action.payload.totalTravaEarned).dividedBy(1e18).toNumber(),
          totalDepositedKnights: action.payload.totalNFTInAllVault,
          totalPolishCount: action.payload.totalPolishTime,
        };
      })
      .addCase(fetchVaultsMeta.rejected, (state, _) => {
        state.fetchFarmingDataStatus = FS.FAIL;
        state.vaultStatistic = undefined;
        state.topAddressEarned = [];
      })

      // fetch vault registry
      .addCase(fetchVaultRegistryData.fulfilled, (state, action) => {
        state.vaultRegistry = {
          totalPages: action.payload.totalPages,
          totalFarmedKnights: action.payload.totalDocs,
          list: action.payload.docs.map((item) => ({
            ...item,
            rewardClaimed: BigNumber(item.rewardClaimed).dividedBy(1e18).toNumber(),
            timeFarmed: item.timeFarmed + new Date().getTime() - item.timestampStake,
            timePolish: item.timePolish,
          })),
        };
      })
      .addCase(fetchVaultRegistryData.rejected, (state, _) => {
        state.fetchFarmingDataStatus = FS.FAIL;
        state.vaultRegistry = undefined;
      }),
});
export default farmingSlice.reducer;

export const { filterChange, updateVaultRegistryConfig } = farmingSlice.actions;
export const selectFarmingSlice = (state) => state.farmingSlice;

export const selectTopAddressEarned = createDraftSafeSelector(
  (state) => selectFarmingSlice(state).topAddressEarned,
  (topAddressEarned) => {
    return topAddressEarned.slice(0, 3);
  }
);
